import styled from 'styled-components'
import posed from 'react-pose'
import Icon from '../../components/Icon'

export const SortStyled = styled.div`

`

export const SortButton = styled.div`
    cursor: pointer;
    font-size: 15px;
    font-weight: 700;
    color: ${({ theme }) => theme.greyishBrown};
`

export const Title = styled.div`
    font-size: 20px;
    font-weight: 700;
    color: ${({ theme }) => theme.greyishBrown};
    margin-top: 20px;
`

const SortItemsPosed = posed.div({
    enter: {
        height: '100vh'
    },
    exit: {
        height: '0vh'
    }
});

export const SortItems = styled(SortItemsPosed)`
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    background: ${({ theme }) => theme.white};
    z-index: 2;
    overflow: hidden;
    padding: 0 15px;
`

export const SortItem = styled.div`
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    color: ${(props) => props.active ? props.theme.greyishBrown : props.theme.brownGrey};
    cursor: pointer;
    margin-top: 30px;
    span {
        margin-right: 10px;
    }
`

export const StyledIcon = styled(Icon).attrs(({ active, theme }) => ({
    color: active ? theme.grassyGreen : theme.brownGrey
}))`
    cursor: pointer;
`